import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_generic_doc_message_template_endpoint_link_RowInterface {
    message_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
    endpoint_hdr_guid: fromDatatype.GuidDataFieldInterface;
    virtual_contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    link_type: fromDatatype.VarcharDatatypeInterface;
    language_code: fromDatatype.VarcharDatatypeInterface;
    guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_fi_generic_doc_message_template_endpoint_link_RowClass
  implements bl_fi_generic_doc_message_template_endpoint_link_RowInterface {
    message_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
    endpoint_hdr_guid: fromDatatype.GuidDataFieldInterface;
    virtual_contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    link_type: fromDatatype.VarcharDatatypeInterface;
    language_code: fromDatatype.VarcharDatatypeInterface;
    guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
  }